import { IPostbackSendFormLang } from '../../../types/lang'

export const postbackSendFormLang: IPostbackSendFormLang = {
	postback_send_form: {
		field_sub_id_label: 'Sub Id',
		field_sub_id_placeholder: 'Insert or enter options...',
		field_postback_status_label: 'Postback Status',
		field_postback_status_placeholder: 'Postback Status',
		field_postback_currency_label: 'Currency',
		field_postback_currency_placeholder: 'Currency',
		field_postback_amount_label: 'Amount',
		field_postback_amount_placeholder: 'Type number',
		msg_postback_send_success: 'Postback sent successfully!',
		msg_postback_send_error: 'Postback send error!',
		btn_send: 'Send'
	}
}